import axios from "axios";
import API_BASE_URL from "../config/apiConfig";

export const fetchCategories = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/categories`);
    return response.data;
  } catch (error) {
    console.error("Error fetching categories:", error);
    throw error;
  }
};

// Homepage and menu: trip cards only (name, photo, price, duration, link).
export const fetchCategorySummaries = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/categories/summary`);
    return response.data;
  } catch (error) {
    console.error("Error fetching categories:", error);
    throw error;
  }
};

// Trip page: the full trip (itinerary, pickups, gallery, FAQs). 404 when the trip is missing or hidden.
export const fetchTripByPath = async (path) => {
  const response = await axios.get(`${API_BASE_URL}/categories/trips/${encodeURIComponent(path)}`);
  return response.data;
};
